module.exports = __webpack_public_path__ + "img/banner-principal.6e4f9195.png";